import {ListingAttributeValueView} from './attribute-schema.service';

export const FULFILLMENT_DROPSHIP = 'dropship';

/** True when listing attributes include fulfillment=dropship. */
export function isDropshipListing(
  attributes: Array<Pick<ListingAttributeValueView, 'code' | 'value' | 'displayValue'>> | null | undefined,
): boolean {
  if (!attributes?.length) {
    return false;
  }
  const fulfillment = attributes.find(attr => attr.code === 'fulfillment');
  if (!fulfillment) {
    return false;
  }
  const raw = fulfillment.value ?? fulfillment.displayValue;
  return `${raw || ''}`.trim().toLowerCase().replace(/[\s-]+/g, '_') === FULFILLMENT_DROPSHIP;
}

/** Buyer-facing ship estimate label, e.g. "Ships in 3–5 days". */
export function dropshipShipsInLabel(
  attributes: Array<Pick<ListingAttributeValueView, 'code' | 'value' | 'displayValue' | 'unit'>> | null | undefined,
): string | null {
  if (!isDropshipListing(attributes)) {
    return null;
  }
  const ships = attributes?.find(attr => attr.code === 'ships_in_days');
  if (!ships) {
    return 'Ships from supplier';
  }
  const days = Number(ships.value ?? ships.displayValue);
  if (!Number.isFinite(days) || days <= 0) {
    return ships.displayValue || 'Ships from supplier';
  }
  const unit = days === 1 ? 'day' : 'days';
  return `Ships within ${days} ${unit}`;
}
